import axios from 'axios'

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem('loginedUser') ? JSON.parse(localStorage.getItem('loginedUser')) : null,
    sites: localStorage.getItem('grantedSites') ? JSON.parse(localStorage.getItem('grantedSites')) : null
  },
  mutations: {
    fetch (state, payload) {
      state.user = payload.user
      state.sites = payload.sites
      localStorage.setItem('loginedUser', JSON.stringify(payload.user))
      localStorage.setItem('grantedSites', JSON.stringify(payload.sites))
    },
    name (state, name) {
      if (state.user && state.user.name) {
        state.user.name = name
        localStorage.setItem('loginedUser', JSON.stringify(state.user))
      }
    },
    mobile (state, mobile) {
      if (state.user && state.user.mobile) {
        state.user.mobile = mobile
        localStorage.setItem('loginedUser', JSON.stringify(state.user))
      }
    },
    email (state, email) {
      if (state.user && state.user.email) {
        state.user.email = email
        state.user.validated_at = null
        localStorage.setItem('loginedUser', JSON.stringify(state.user))
      }
    },
    validated (state) {
      if (state.user && state.user.email) {
        state.user.validated_at = new Date()
        localStorage.setItem('loginedUser', JSON.stringify(state.user))
      }
    },
    avatar (state, url) {
      if (state.user) {
        state.user.avatar_url = url
        localStorage.setItem('loginedUser', JSON.stringify(state.user))
      }
    },
    reset (state) {
      state.user = null
      state.sites = null
      localStorage.removeItem('loginedUser')
      localStorage.removeItem('grantedSites')
    }
  },
  actions: {
    async fetch ({ commit }) {
      let [userRes, sitesRes] = await Promise.all([
        axios.get('/web/user/info/'),
        axios.get('/web/user/site/')
      ])
      commit('fetch', {user: userRes.data, sites: sitesRes.data})
    },
    name ({ commit }, name) {
      commit('name', name)
    },
    mobile ({commit}, mobile) {
      commit('mobile', mobile)
    },
    email ({ commit }, email) {
      commit('email', email)
    },
    validated ({ commit }) {
      commit('validated')
    },
    avatar ({ commit }, url) {
      commit('avatar', url)
    }
  },
  getters: {
    info: (state) => {
      if (state.user) { return state.user }
      if (localStorage.getItem('loginedUser')) {
        return JSON.parse(localStorage.getItem('loginedUser'))
      }
      return null
    },
    id: (state) => {
      if (state.user && state.user.id) { return state.user.id }
      return null
    },
    avatar: (state, getters) => getters.info ? getters.info.avatar_url : null,
    sites: (state) => state.sites || []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/UserStore.js